<template lang="pug">
  field(:label="label", :errors="errors", :required="required", :inline="inline", :nopadding="nopadding")
    div(slot="field")
      .selectWrapper
        .select(:class="{selectFocus: dropdownOpen}", v-on:click="(dropdownOpen) ? dropdownOpen = false : dropdownOpen = true; setFocus()"  v-click-outside="onClickOutside") {{currentLabel}}&nbsp;
          v-icon.dropdown-icon(v-if="dropdownOpen" name="times" scale="0.9" style="margin-top: 2px")
          v-icon.dropdown-icon(v-if="!dropdownOpen" name="angle-down" scale="1.2")
        transition(name="fade")
          #dropdown.grid(v-show="dropdownOpen"  @click.stop)
            .search.fixed(v-if="isDrugs")
              input(v-model="searchingText", type="text", placeholder="Введите название препарата..." ref='search' :id="generateUUID" class="searchField")
            .search.fixed(v-if="!isDrugs")
              input(v-model="searchingText", type="text", :placeholder="placeholder" ref='search' :id="generateUUID" class="searchField")
              //FOR DRUGS
            .scrollable(v-if="isDrugs" )
              .item.null(v-if="(!required || !innerValue) && searchingText.length == 0 && filteredResults.length > 0", @click="updateValue(null, '')") Не выбрано
              .item(v-for="item in filteredResults" :key="item[valueProp]" @click="updateValue(item.name, item[labelProp])")
                span(v-if="labelProp && !hideLabelProp") {{item[labelProp]}}
                slot(name="label", :item="item")
              .gag(v-if='filteredResults.length == 0 && filter') Начните набор текста
                 //FOR DIAGNOSIS
            .scrollable(v-if="!isDrugs" )
              .item.null(v-if="(!required || !innerValue) && searchingText.length == 0 && filteredResults.length > 0", @click="updateValue(null, '')") Не выбрано
              .item(v-for="item in filteredResults" :key="item[valueProp]" @click="updateValue(item[valueProp], item[labelProp])")
                span(v-if="labelProp && !hideLabelProp") {{item[labelProp]}}
                slot(name="label", :item="item")
              .gag(v-if='filteredResults.length == 0 && filter') Начните набор текста
</template>

<script>
import Field from '@/components/fields/FieldContainer'
import Icon from 'vue-awesome/components/Icon'
import vClickOutside from 'v-click-outside'

export default {
  components: {
    Field,
    'v-icon': Icon
  },
  props: [
    'label',
    'errors',
    'items',
    'valueProp',
    'labelProp',
    'value',
    'required',
    'hideLabelProp',
    'inline',
    'filter',
    'nestedItems',
    'nopadding',
    'notfiltering',
    'isDrugs',
    'placeholder'
  ],
  directives: {
    clickOutside: vClickOutside.directive
  },

  data: () => ({
    dropdownOpen: false,
    searchingText: '',
    innerValue: ''
  }),
  watch: {
    searchingText () {
      this.$emit('searchString', this.searchingText)
    }
  },
  computed: {
    filteredResults () {
      if (this.searchingText.length > 0 && !this.notfiltering) {
        return this.items.filter(
          item =>
            item[this.labelProp]
              .toLowerCase()
              .indexOf(this.searchingText.toLowerCase(), 0) >= 0
        )
      }

      return this.items
    },
    id () {
      return this._uid
    },
    currentLabel () {
      if (
        this.items.filter(item => item[this.valueProp] == this.value).length > 0
      ) {
        return this.items.filter(item => item[this.valueProp] == this.value)[0][
          this.labelProp
        ]
      }

      return ''
    },
    generateUUID () {
      const s4 = () =>
        Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)
      return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`
    }
  },
  created () {
    this.innerValue = this.value
  },
  methods: {
    updateValue: function (value) {
      this.innerValue = value
      this.$emit('input', value)
      this.dropdownOpen = false
      this.searchingText = ''
    },
    setFocus () {
      this.$nextTick(() => this.$refs.search.focus())
    },
    onClickOutside () {
      if (this.dropdownOpen) {
        this.dropdownOpen = false
      }
    }
  }
}
</script>

<style scoped lang="sass">
.grid
  display: grid
  // max-width: 800px
  grid-template-rows: minmax(min-content, 1fr) 1000fr
  grid-gap: 0
.fixed
  grid-row: 1

.scrollable
  background: white
  grid-row: 2
  overflow-y: auto
  padding-top: 5px

.null
  color: #777

.selectWrapper
  position: relative

.select
  padding: 7px 0 7px 10px
  display: block
  font-size: 14px
  border: 1px solid #ccc
  border-radius: 4px 4px 4px 4px
  user-select: none
  cursor: pointer
  background: white
  text-align: left

.selectFocus
  border-color: rgba(26, 163, 255, 0.8)
  border-radius: 4px 4px 0px 0px
.dropdown-icon
  float: right
  //padding-right: 20px
  margin-right: 5px

#dropdown
  border: 1px solid #CCC
  font-size: 14px
  max-height: 300px
  min-height: 40px
  overflow: auto
  position: absolute
  z-index: 30
  width: 100%
  background-color: white
  line-height: 2
  box-sizing: border-box
  text-align: left
  user-select: none
  padding-bottom: 1px
  box-shadow: 0 3px 15px -10px black

.item
  padding: 3px 10px
  font-size: 14px

.gag
  padding: 3px 10px

.item:hover
  background: #0e7afd
  color: white !important
  cursor: pointer

.topItem
  font-weight: 700

.nestedItem
  padding-left: 30px

.searchField
  border: none
  background: #ebf7f9
  padding: 10px 10px
  font-size: 14px
  outline: none
  width: calc(100% - 20px)

.fade-enter-active, .fade-leave-active
  transition: opacity .4s
.fade-enter, .fade-leave-to
  opacity: 0
</style>
